<template>
  <div class="background">
    <div class="card">
      <img
        src="../assets/back.png"
        alt="Return"
        class="return-icon"
        @click="$router.go(-1)"
      />
      <div class="title">Create your account 2/3</div>
      <div class="reminders">
        <div class="content">
          <div class="sub-title">Account Number (Address)</div>
          <div class="copy">
            <div class="left">
              {{ walletInfo ? walletInfo.address : "none" }}
            </div>
            <div class="right">
              <img
                :src="copyStatus_address == 0 ? copyPic : copiedPic"
                alt=""
                @click="copyToClipboard('address', walletInfo.address)"
              />
            </div>
          </div>
        </div>
        <div class="content">
          <div class="sub-title">Password (Private Key)</div>
          <div class="copy">
            <div class="left">
              {{ walletInfo ? walletInfo.privateKey : "none" }}
            </div>
            <div class="right">
              <img
                :src="copyStatus_password == 0 ? copyPic : copiedPic"
                alt=""
                @click="copyToClipboard('passsword', walletInfo.privateKey)"
              />
            </div>
          </div>
        </div>
        <div class="content">
          <div class="sub-title">Seed Phrase (Mnemonic)</div>
          <div class="copy">
            <div class="left">
              {{ walletInfo ? walletInfo.mnemonic : "none" }}
            </div>
            <div class="right">
              <img
                :src="copyStatus_mnemonic == 0 ? copyPic : copiedPic"
                alt=""
                @click="copyToClipboard('mnemonic', walletInfo.mnemonic)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="button-box">
        <button class="button" @click="saveToFile()">
          <span>Save</span>
        </button>
        <div class="space1"></div>
        <button :class="!isSave ? 'button grey' : 'button'" @click="jump()">
          <span @click="jump()">Next</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Bip39, Random } from "@cosmjs/crypto";
const { toBech32, fromBech32 } = require("@cosmjs/encoding");
import { Secp256k1HdWallet } from "@cosmjs/amino";
import { Buffer } from "buffer";

export default {
  data() {
    return {
      selectedPic: require("../assets/selected.png"),
      unSelectedPic: require("../assets/not-select.png"),
      walletInfo: null,
      isSave: false,
      copyPic: require("../assets/copy.png"),
      copiedPic: require("../assets/copied.png"),
      copyStatus_address: 0,
      copyStatus_password: 0,
      copyStatus_mnemonic: 0,
    };
  },
  mounted() {
    this.generateWallet();
  },
  methods: {
    async generateWallet() {
      const mnemonic = Bip39.encode(Random.getBytes(16)).toString();
      const wallet = await Secp256k1HdWallet.fromMnemonic(mnemonic);
      const [firstAccount] = await wallet.getAccounts();
      let address = firstAccount.address;
      const accounts = await wallet.getAccountsWithPrivkeys();
      const privateKeyUint8Array = accounts[0].privkey;
      const privateKey = Buffer.from(privateKeyUint8Array).toString("hex");
      let decodedAddress = fromBech32(address);
      address = toBech32("cnho", decodedAddress.data);
      this.walletInfo = {
        address: address,
        privateKey: privateKey,
        mnemonic: mnemonic,
      };
    },
    saveToFile() {
      const file = new Blob([JSON.stringify(this.walletInfo, null, 2)], {
        type: "text/plain",
      });
      const a = document.createElement("a");
      URL.createObjectURL(file);
      a.href = URL.createObjectURL(file);
      a.download = "wallet_" + this.walletInfo.address + ".txt";
      a.click();
      this.isSave = true;
    },
    copyToClipboard(place, text) {
      if (place == "address") {
        this.copyStatus_address = 1;
        setTimeout(() => {
          this.copyStatus_address = 0;
        }, 1000);
      } else if (place == "passsword") {
        this.copyStatus_password = 1;
        setTimeout(() => {
          this.copyStatus_password = 0;
        }, 1000);
      } else if (place == "mnemonic") {
        this.copyStatus_mnemonic = 1;
        setTimeout(() => {
          this.copyStatus_mnemonic = 0;
        }, 1000);
      }
      // 创建一个 textarea 元素
      let textarea = document.createElement("textarea");
      // 设置 textarea 的值为你想要复制的文本
      textarea.value = text;
      // 将 textarea 添加到 DOM 中
      document.body.appendChild(textarea);
      // 选择 textarea 的内容
      textarea.select();
      try {
        // 尝试复制 textarea 的内容
        document.execCommand("copy");
      } catch (e) {
        console.error("复制失败", e);
      }
      // 清理你创建的 textarea
      document.body.removeChild(textarea);
    },
    jump() {
      if (this.isSave) {
        this.$router.push("/create-3?address=" + this.walletInfo.address);
      }
    },
  },
};
</script>
<style scoped>
html {
  /* width: 1920px;
    height: 937px; */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background: #006e54;
  border-radius: 0px 0px 0px 0px;
}

.card {
  margin: calc(100 / 937 * 100vh) auto 0;
  position: relative;
  width: calc(556 / 1920 * 100vw);
  height: calc(774 / 937 * 100vh);
  background: #ffffff;
  border-radius: calc(28 / 1920 * 100vw);
}
@media (max-width: 600px) {
  .card {
    width: 90vw; /* 在小屏幕上，让卡片宽度更适应屏幕 */
    margin-top: 10vh; /* 调整边距 */
    border-radius: 10px; /* 调整边角半径 */
  }
  .return-icon {
    left: calc(10 / 90 * 100vw) !important;
    width: calc(5 / 90 * 100vw) !important;
    height: calc(5 / 90 * 100vw) !important;
  }

  .reminders {
    position: absolute;
    left: calc(10 / 90 * 100vw) !important;
    top: calc(180 / 932 * 100vh) !important;
    overflow: none !important;
  }
  .title {
    position: absolute;
    left: calc(10 / 90 * 100vw) !important;
    font-size: 21px !important;
  }
  .content {
    line-height: 22px !important;
  }

  .content .sub-title {
    height: calc(100 / 932 * 100vh) !important;
    font-size: calc(15 / 932 * 100vh);
    line-height: calc(18 / 932 * 100vh);
    margin-bottom: calc(4 / 932 * 100vh);
  }
  .content .copy {
    display: flex;
    width: calc(65 / 90 * 100vw) !important;
    background: #f4fbf8;
    border-radius: 6px 6px 6px 6px;
  }
  .content .copy .left {
    width: calc(50 / 90 * 100vw) !important;
    font-size: calc(17 / 932 * 100vh);
    margin: calc(10 / 932 * 100vh) 0 calc(10 / 932 * 100vh)
      calc(12 / 932 * 100vh);
  }
  .content .copy .right img {
    width: calc(6 / 90 * 100vw) !important;
    height: calc(6 / 90 * 100vw) !important;
    margin: calc(5 / 90 * 100vw) calc(3 / 90 * 100vw) calc(1 / 90 * 100vw) !important;
  }
  .button-box {
    position: absolute;
    bottom: calc(116 / 932 * 100vh) !important;
    left: calc(10 / 90 * 100vw) !important;
  }
  .button {
    width: calc(30 / 90 * 100vw) !important;
    height: calc(9 / 90 * 100vw) !important;
  }
  .space1 {
    width: calc(1 / 90 * 100vw) !important;
  }
  .button span {
    width: calc(50 / 1920 * 100vw);
    height: calc(20 / 1920 * 100vw);
    font-size: 18px !important;
    line-height: 18px !important;
  }
}
.return-icon {
  position: absolute;
  margin: 0;
  padding: 0;
  width: calc(28 / 1920 * 100vw);
  height: calc(28 / 1920 * 100vw);
  top: calc(80 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  background: #ffffff;
}

.reminders {
  position: absolute;
  top: calc(212 / 937 * 100vh);
  left: calc(80 / 1920 * 100vw);
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: calc(17 / 1920 * 100vw);
  color: #000000;
  line-height: calc(22 / 1920 * 100vw);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.content {
  display: flex;
  height: calc(95 / 937 * 100vh);
  flex-direction: column;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: calc(17 / 1920 * 100vw);
  color: #000000;
  line-height: calc(22 / 1920 * 100vw);
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: calc(36 / 937 * 100vh);
}
.content .sub-title {
  display: block;
  height: calc(18 / 937 * 100vh);
  font-family: Roboto-Medium;
  font-weight: 500;
  font-size: calc(15 / 937 * 100vh);
  color: #000000;
  line-height: calc(18 / 937 * 100vh);
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: calc(4 / 937 * 100vh);
}
.content .copy {
  display: flex;
  width: calc(396 / 1920 * 100vw);
  /* height: calc(80 / 937 * 100vh); */
  background: #f4fbf8;
  border-radius: 6px 6px 6px 6px;
}
.content .copy .left {
  width: calc(332 / 1920 * 100vw);
  font-size: calc(17 / 937 * 100vh);
  font-family: Roboto-Regular;
  color: #000000;
  word-wrap: break-word;
  margin: calc(10 / 937 * 100vh) 0 calc(10 / 937 * 100vh) calc(12 / 937 * 100vh);
}
.content .copy .right img {
  width: calc(28 / 1920 * 100vw);
  height: calc(28 / 1920 * 100vw);
  margin: calc(10 / 1920 * 100vw) calc(12 / 1920 * 100vw)
    calc(22 / 1920 * 100vw);
}
/* .content .copy .right img:active {
  opacity: 0.2;
} */
.button-box {
  position: absolute;
  bottom: calc(116 / 937 * 100vh);
  left: calc(75 / 1920 * 100vw);
  display: flex;
}
.button {
  width: calc(194 / 1920 * 100vw);
  height: calc(40 / 1920 * 100vw);
  background: #028760;
  border-radius: 6px 6px 6px 6px;
  border: none;
}
.grey {
  opacity: 0.2;
}
.space1 {
  height: 1px;
  width: calc(10 / 1920 * 100vw);
}
.button span {
  width: calc(50 / 1920 * 100vw);
  height: calc(20 / 1920 * 100vw);
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: calc(17 / 1920 * 100vw);
  color: #ffffff;
  line-height: 0px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
</style>
